export default "__VITE_ASSET__6gr8$OnP__"